<mat-menu>
  @for (user of users$ | async; track $index) {
    <button mat-menu-item (click)="onClickUser(user)">
      <span>{{ user | userLabel }}</span>
    </button>
  }
  @if ((users$ | async)?.length === 0) {
    <div class="menu-empty">
      <mat-icon>warning</mat-icon>
      <span> Aucun utilisateur trouvé</span>
    </div>
  }
</mat-menu>
